module.exports = __webpack_public_path__ + "static/media/DrukText-Bold.c53c9f74.otf";